import { EMAIL_UPDATE, EMAIL_UPDATE_DONE, EMAIL_UPDATE_ERR, CONFIRM_EMAIL_CHANGE, CONFIRM_EMAIL_UPDATE_DONE, CONFIRM_EMAIL_UPDATE_ERR, EMAIL_UPDATE_RESET } from './actionTypes';
export const emailUpdate = (data) => ({
    type: EMAIL_UPDATE,
    data
});
export const emailUpdateDone = (data) => ({
    type: EMAIL_UPDATE_DONE,
    data
});
export const emailUpdateError = (data) => ({
    type: EMAIL_UPDATE_ERR,
    data
});
export const confirmEmailUpdate = (data) => ({
    type: CONFIRM_EMAIL_CHANGE,
    data
});
export const doneConfirmEmailUpdate = (data) => ({
    type: CONFIRM_EMAIL_UPDATE_DONE,
    data
});
export const errorConfirmEmailUpdate = (data) => ({
    type: CONFIRM_EMAIL_UPDATE_ERR,
    data
});
export const emailUpdateReset = () => ({ type: EMAIL_UPDATE_RESET });
//# sourceMappingURL=actionCreators.js.map